import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import ClientesPage from "./config/ClientesPage";
import EspeciesPage from "./config/EspeciesPage";
import RazasPage from "./config/RazasPage";
import EquiposPage from "./config/EquiposPage";
import ExamenesPage from "./config/ExamenesPage";
import CaratulasEspeciePage from "./config/CaratulasEspeciePage";
import WhatsAppPage from "./config/WhatsAppPage";
import EmailPage from "./config/EmailPage";
import UsuariosPage from "./config/UsuariosPage";
import MedicosPage from "./config/MedicosPage";
import CajaCategoriasPage from "./config/CajaCategoriasPage";
import { Settings, Users, Dna, Shapes, Cpu, FlaskConical, BookOpen, MessageCircle, Mail, UserCog, Stethoscope, Wallet } from "lucide-react";
import { canAccess } from "../utils/auth";

const SECTIONS = [
  { key: "clientes",          label: "Clientes",          icon: Users,          component: ClientesPage },
  { key: "especies",          label: "Especies",          icon: Dna,            component: EspeciesPage },
  { key: "razas",             label: "Razas",             icon: Shapes,         component: RazasPage },
  { key: "equipos",           label: "Equipos",           icon: Cpu,            component: EquiposPage },
  { key: "examenes",          label: "Exámenes",          icon: FlaskConical,   component: ExamenesPage },
  { key: "caratulas_especie", label: "Carátulas especie", icon: BookOpen,       component: CaratulasEspeciePage },
  { key: "medicos",           label: "Médicos",           icon: Stethoscope,    component: MedicosPage },
  { key: "whatsapp",          label: "WhatsApp",          icon: MessageCircle,  component: WhatsAppPage },
  { key: "email",             label: "Correo",            icon: Mail,           component: EmailPage },
  { key: "usuarios",          label: "Usuarios",          icon: UserCog,        component: UsuariosPage },
  { key: "caja_categorias",   label: "Categorías de caja", icon: Wallet,        component: CajaCategoriasPage },
];

const ConfigPage = () => {
  const [section, setSection] = useState("clientes");

  // Filtrar tabs por permiso; si no hay sub-permisos configurados pero tiene /config, mostrar todo
  const visibleSections = (() => {
    const filtered = SECTIONS.filter((s) => canAccess(`/config/${s.key}`));
    if (filtered.length === 0) return SECTIONS;
    return filtered;
  })();

  const active = visibleSections.find((s) => s.key === section) || visibleSections[0];
  const ActiveComponent = active?.component;

  return (
    <AppLayout>
      <div className="p-6 space-y-5">
        {/* Cabecera */}
        <div className="flex items-center gap-3">
          <div className="p-2 bg-brand-100 rounded-xl">
            <Settings className="h-5 w-5 text-brand-600" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-800">Configuración</h1>
            <p className="text-sm text-gray-500">Gestiona los catálogos del sistema</p>
          </div>
        </div>

        {/* Pestañas de sección */}
        <div className="bg-white rounded-2xl border border-brand-100 shadow-card p-1.5 flex flex-wrap gap-1">
          {visibleSections.map((sec) => {
            const Icon = sec.icon;
            const isActive = section === sec.key;
            return (
              <button
                key={sec.key}
                onClick={() => setSection(sec.key)}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? "bg-brand-gradient text-white shadow-sm"
                    : "text-gray-600 hover:bg-brand-50 hover:text-brand-700"
                }`}
              >
                <Icon className="h-4 w-4" />
                {sec.label}
              </button>
            );
          })}
        </div>

        {/* Contenido de sección */}
        <div className="animate-fadeIn">
          <ActiveComponent />
        </div>
      </div>
    </AppLayout>
  );
};

export default ConfigPage;
